export default __webpack_public_path__ + "static/media/menu-04-pricing-w.9e7b0f46.svg";